export default function activeDiscount(categories) {
  if (!categories || !Array.isArray(categories)) {
    return null;
  }
  const activeDiscount = categories.find(
    (category) => category.discount && category.discount.percent !== null
  );
  if (activeDiscount) {
    if (activeDiscount.discount.percent) {
      return {
        type: "percent",
        discount: activeDiscount.discount.percent,
      };
    }
    if (activeDiscount.discount.price) {
      return { type: "price", discount: activeDiscount.discount.price };
    }
    return null;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/helpers/activeDiscount.js